module.exports = __webpack_public_path__ + "static/img/background.cc3db51e.svg";